import React from 'react';

export const TruncateText = (text, length) => {
    if (text) {
        if (text.length > length) {
            return text.substring(0, length) + "...";
        } else {
            return text;
        }
    } else {
        return "";
    }
}

export const CsvToIntArray = (text) => {
    if (text && text.trim().length > 0) {
        return text.split(',').map(x => Number.parseInt(x));
    }

    return [];
}

//converts all URLs that start with 'https' in a string of text to <a href> elements
//returns an array of JSX elements. <span> for string and <a> for links 
export const ConvertLinksToHyperLinks = (text) => {
    let result = [];
    let renderAllLinks = (text, result) => {
        let linkStart = text.indexOf("https");
        if (linkStart === -1) {
            result.push(<span>{text}</span>)
            return result;
        }

        let partBeforeLink = text.substring(0, linkStart);
        let restOfText = text.substring(linkStart);

        let partAfterLink = "";
        let link = "";
        let linkEnd = restOfText.indexOf(" ");

        if (linkEnd === -1) {
            link = restOfText;
            result.push(<span>{partBeforeLink}</span>, <a href={link} target='_blank'  rel='noopener noreferrer'>{link}</a>)
            return result;
        }
        else{
            link = restOfText.substring(0, linkEnd);
            partAfterLink = restOfText.substring(linkEnd);
            result.push(<span>{partBeforeLink}</span>, <a href={link} target='_blank'  rel='noopener noreferrer'>{link}</a>)
            return renderAllLinks(partAfterLink, result);
        }
    }
    return renderAllLinks(text, result);
}

export const InsertSpaceEvery4Chars = (str) => {
  return str.replace(/(.{4})/g, '$1 ');
}
